

































































































































import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import BuscadorMantenedor from '@/reusable/Grid/BuscadorMantenedor.vue';
import MantenedorGridTodos from '@/reusable/Grid/MantenedorGridTodos.vue';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy, Accion } from '@/config/enums';
import { ComponenteBase } from '@/views/base/ComponenteBase';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import Confirmation from '@/components/Confirmation.vue';
import ExportarAgGridButton from '@/reusable/Grid/ExportarAgGridButton.vue';
import { EstadoGrillaVm } from '@/interfaces/EstadoGrillaVm';
import { LoadingService } from '@/services/loadingService';
import { PermisoAccion } from '@/views/base/VariablesPermisos';
import { AgGridUtil } from '@/agGridUtil/agGridUtil';
import PopUpGeneratedReports from './PopUpGeneratedReoports.vue';
import moment from 'moment';
import { getUserId } from '@/pantallas/Conecta/MantenedorLocalidad/helpers/getUserId';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { Funcionalidades } from '@/config/funcionalidades';
import { actionsEvent } from '@/setup';
import VerDetalleCuadratura from '@/pantallas/OrdenesServicio/VerDetalleCuadratura.vue';
import { AlertaBackend } from '@/interfaces/Alertas';
@Component({
  components: {
    BuscadorMantenedor,
    Confirmation,
    MantenedorGridTodos,
    VerDetalleCuadratura,
    ExportarAgGridButton,
    DatePicker,
    FormFieldsContainer,
    PopUpGeneratedReports,
  },
})
export default class CuadraturaOrdenesServicioPantalla extends ComponenteBase {
  startRow: any = '';
  idSeleccionado: string = '';
  glosa: string = '';
  categoriatipo: string = '';
  endRow: string = '';
  patente: string = '';
  estadocuadratura: string = '';
  estadocrmepc: string[] = [];
  razonestadocrmepc: string[] = [];
  estadofecha: string = '';
  serverSide: any;
  axios: AxiosVue = new AxiosVue(ServicioProxy.MS);
  loadingService = new LoadingService();
  gridApi: GridApi;
  msgReport: string = '';
  columnApi: ColumnApi;
  fechaInicio: string | null = null;
  fechaFin: string | null = null;
  now: string = moment().format('YYYY-MM-DD');
  agGridUtil: AgGridUtil;
  showPopUpReport: boolean = false;
  estadoGrillaVm: EstadoGrillaVm;
  patenteSeleccionada: string = '';
  estadoCudratura: string = '';
  estados = [
    { texto: 'Pendiente', valor: 'Pendiente' },
    { texto: 'Finalizado', valor: 'Finalizado' },
    { texto: 'No Instalado', valor: 'No Instalado' },
  ];
  estadosepc = [
    { texto: 'Activo', valor: 'Activo' },
    { texto: 'Inactivo', valor: 'Inactivo' },
    { texto: 'No existe en CRM', valor: 'NULL' },
  ];
  razonestadosepc = [
    { texto: 'Anulación de la Venta', valor: 'Anulación de la Venta' },
    { texto: 'Anulación del Arriendo', valor: 'Anulación del Arriendo' },
    { texto: 'Baja por Renovación', valor: 'Baja por Renovación' },
    { texto: 'Baja temporal', valor: 'Baja temporal' },
    { texto: 'Cambio por garantía', valor: 'Cambio por garantía' },
    { texto: 'Cambio por venta', valor: 'Cambio por venta' },
    { texto: 'Con Falla', valor: 'Con Falla' },
    { texto: 'Inactivo', valor: 'Inactivo' },
    { texto: 'Instalado', valor: 'Instalado' },
    { texto: 'Por Baja Cobranzas', valor: 'Por Baja Cobranzas' },
    { texto: 'Por Baja Comercial', valor: 'Por Baja Comercial' },
    { texto: 'Por Baja Demo', valor: 'Por Baja Demo' },
    { texto: 'Por Cambio de Plataforma', valor: 'Por Cambio de Plataforma' },
    { texto: 'Por Cambio Razón Social', valor: 'Por Cambio Razón Social' },
    { texto: 'Por Migración', valor: 'Por Migración' },
    { texto: 'Por Reservar', valor: 'Por Reservar' },
    { texto: 'Preparado', valor: 'Preparado' },
    { texto: 'Recuperado', valor: 'Recuperado' },
    { texto: 'Reservado', valor: 'Reservado' },
  ];
  tipo_fecha = [
    { texto: 'Fecha creación', valor: 'fecha_creacion' },
    { texto: 'Fecha revisión', valor: 'fecha_revision' },
  ];
  hashpaginacion: string = '';
  total_registros: string = '0';

  mostrarDetalle: boolean = false;
  searchReport: string = '';
  readonly funcionalidad: Funcionalidades =
    Funcionalidades.CuadraturaOrdenesServicio;
  enrichedGridOptions: GridOptions = null;
  readonly gridOptions: GridOptions;
  serie: string = '';
  formattedFechaInicio: string = '';
  formattedFechaFin: string = '';
  tipoFecha: string = '';
  showModalViewDetail: boolean = false;
  lstorden: AlertaBackend[] = [];

  accionDetalle: PermisoAccion = {
    accionCodigo: 4,
    visible: false,
  };

  accionExportar: PermisoAccion = {
    accionCodigo: 6,
    visible: false,
  };

  accionesTotales: PermisoAccion[] = [this.accionDetalle, this.accionExportar];

  handleCloseReport(): void {
    this.showPopUpReport = false;
    this.msgReport = '';
  }
  mounted() {}

  constructor() {
    super();
    actionsEvent.onVerDetalle(this.handleVerDetalleClick);

    this.gridOptions = {
      onGridReady: this.onGridReady, // Método que se ejecuta cuando la cuadrícula está lista
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 50,
      cacheBlockSize: 50,
      paginationAutoPageSize: false,
      serverSideDatasource: this.serverSide,
      suppressRowClickSelection: true,
      rowModelType: 'serverSide',
      columnDefs: [
        {
          headerName: 'Serie',
          field: 'serie',
        },
        {
          headerName: 'Fecha Creacíon',
          field: 'fecha_creacion',
        },
        {
          headerName: 'Fecha Revisíon',
          field: 'fecha_revision',
        },
        {
          headerName: 'Estado Cuadratura',
          field: 'estado_cuadratura',
          cellRenderer: params => {
            const isFinalizado = params.value === 't';
            return this.iconState(params.value);
          },
        },
        {
          headerName: 'Estado CRM',
          field: 'estado_epc',
        },
        {
          headerName: 'Razón Estado CRM',
          field: 'razonestado_epc',
        },
        {
          headerName: 'Glosa',
          field: 'glosa',
        },
        {
          headerName: 'Categoria Glosa',
          field: 'categoria_glosa',
        },
      ],
    };
  }

  // Método para ajustar automáticamente el tamaño de las columnas
  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }

  async onGridReady(params: GridReadyEvent) {
    // Lógica para configurar la cuadrícula cuando está lista
    this.loadingService.showLoading(); // Muestra el indicador de carga
    this.gridApi = params.api; // Almacena la API de ag-Grid
    this.columnApi = params.columnApi; // Almacena la API de columnas de ag-Grid
    const self = this;
    this.loadingService.showLoading();

    this.serverSide = {
      getRows(params: any): void {
        // Lógica para obtener las filas del lado del servidora
        params.request.search = self.searchReport;
        params.request.paginationPageSize = self.gridOptions.cacheBlockSize;
        const requestData = {
          startRow: params.request.startRow,
          endRow: params.request.endRow,
          patente: self.serie,
          estado_cuadratura: self.estadocuadratura,
          fecha_inicio: self.formattedFechaInicio,
          fecha_fin: self.formattedFechaFin,
          tipo_fecha: self.estadofecha,
          hashpaginacion: self.hashpaginacion,
          total_registros: self.total_registros,
          estado_epc: self.estadocrmepc,
          razon_estado_epc: self.razonestadocrmepc,
          request: params.request,
        };

        console.log('Solicitud enviada al servicio:', requestData);
        self.axios.http
          .post(
            'Metabase/PostgenericA/CuadraturaServicios/getCuadraturaPatentes',
            requestData
          )
          .then((response: any) => {
            if (response.data.CODIGO_RESPUESTA == '1') {
              self.lstorden = response.data.data;
              self.gridApi.setRowData(response.data.data); // Actualiza los datos de la cuadrícula
              self.hashpaginacion = response.data.hashpaginacion;
              self.total_registros = response.data.total_registros;
              params.successCallback(response.data.data, self.total_registros);
              self.autoSizeAll(false); // Ajusta automáticamente el tamaño de las col
              self.gridApi.hideOverlay();
            } else {
              // Lógica para manejar la respuesta fallida
              params.successCallback([{}], 0); // Ejecuta el callback de éxito con una matriz vacía
              self.gridApi.showNoRowsOverlay(); // Muestra la superposición cuando no hay filas
            }
            self.loadingService.hideLoading();
          })
          .catch((error: any) => {
            console.log(error);
          })
          .finally(() => {
            // Lógica a ejecutar después de la llamada HTTP
            self.gridApi.setDomLayout('autoHeight');
            self.loadingService.hideLoading();
          });
      },
    };
    // Configura el lado del servidor para la cuadrícula
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  clearFilters() {
    this.serie = '';
    this.searchReport = '';
    this.estadocuadratura = '';
    this.fechaInicio = '';
    this.formattedFechaInicio = '';
    this.formattedFechaFin = '';
    this.fechaFin = '';
    this.estadofecha = '';
    this.estadocrmepc = [];
    this.hashpaginacion = '';
    this.total_registros = '';
    this.razonestadocrmepc = [];
    this.gridApi.purgeServerSideCache();
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  onFilterTextBoxChanged() {
    this.hashpaginacion = '';
    this.total_registros = '0';
    if (this.fechaInicio) {
      this.formattedFechaInicio = moment(this.fechaInicio).format('YYYY-MM-DD');
    }
    if (this.fechaFin) {
      this.formattedFechaFin = moment(this.fechaFin).format('YYYY-MM-DD');
    }
    console.log('Filtros aplicados:', {
      patente: this.serie,
      estado_cuadratura: this.estadocuadratura,
      fechaInicio: this.formattedFechaInicio,
      fechaFin: this.formattedFechaFin,
      tipo_fecha: this.estadofecha,
    });

    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  async handleVerDetalleClick(params: ICellRendererParams) {
    this.idSeleccionado = params.data.id;
    this.glosa = params.data.glosa;
    this.categoriatipo = params.data.categoria_glosa;
    this.patenteSeleccionada = params.data.serie;
    this.estadoCudratura = params.data.estado_cuadratura;
    const estadoDisplay = this.getEstadoCuadraturaDisplayValue(
      this.estadoCudratura
    );
    this.showModalViewDetail = true;
  }

  handleCerrar(): void {
    this.showModalViewDetail = false;
    this.gridApi.purgeServerSideCache();
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  iconState(isFinalizado: string): string {
    //const estado = isFinalizado ? 'Finalizado' : 'Pendiente';
    //const color = isFinalizado ? 'rgb(42 255 78)' : 'rgb(255 58 58)';
    let estado = '';
    if (isFinalizado == 'true') {
      estado = 'Finalizado';
    } else if (isFinalizado == 'false') {
      estado = 'Pendiente';
    } else if (isFinalizado == 'No Instalado') {
      estado = 'No Instalado';
    }

    let color = '';
    if (isFinalizado == 'true') {
      color = 'rgb(42 255 78)';
    } else if (isFinalizado == 'false') {
      color = 'rgb(255 58 58)';
    } else if (isFinalizado == 'No Instalado') {
      color = 'rgb(191 191 191)';
    }

    // Retorna el HTML para el icono y el texto
    return `<i class="material-icons" style="width: 15px; height: 15px; margin-top: 7px; border-radius: 50%; background: ${color};"></i>
          <span style="padding-left: 20px;">${estado}</span>`;
  }

  getEstadoCuadraturaDisplayValue(estadoCuadratura: string): string {
    return estadoCuadratura === 't' ? 'Finalizado' : 'Pendiente';
  }
  get estadoCuadraturaDisplay(): string {
    return this.getEstadoCuadraturaDisplayValue(this.estadoCudratura);
  }

  async getCSV(): Promise<void> {
    const userId = getUserId();
    const user = localStorage.getItem('clienteDefecto');

    const body = {
      userId: userId,
      user: user,
      fecha_inicio: this.fechaInicio,
      fecha_fin: this.fechaFin,
      serie: this.serie,
      estado_cuadratura: this.estadocuadratura,
      tipo_fecha: this.estadofecha,
      estado_epc: this.estadocrmepc,
      razon_estado_epc: this.razonestadocrmepc,
    };

    this.loadingService.showLoading();

    try {
      const response = await this.axios.http.post(
        'Metabase/PostgenericA/CuadraturaServicios/export_excel',
        body
      );

      if (response.data && response.data.CODIGO_RESPUESTA === '1') {
        this.msgReport = response.data.MENSAJE_RESPUESTA;
        this.showPopUpReport = true;
      } else {
        this.$snotify.error(response.data.MENSAJE_RESPUESTA, { timeout: 3000 });
      }
    } catch (error) {
      // Manejo de errores de red, servidor, etc.
      console.error('Error al generar el reporte:', error);
      this.$snotify.error(
        'Error al generar el reporte. Por favor, inténtelo de nuevo más tarde.',
        { timeout: 3000 }
      );
    } finally {
      this.loadingService.hideLoading();
    }
  }

  handleEstadoActualizado(nuevoEstado: string) {
    this.estadoCudratura = nuevoEstado;
  }
  handleGlosaUpdated(data: { glosa: string; categoria: string }) {
    this.glosa = data.glosa;
    this.categoriatipo = data.categoria;
  }
}
